import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=fe0a9fb4&scoped=true&"
import script from "./PackageDetails.vue?vue&type=script&lang=js&"
export * from "./PackageDetails.vue?vue&type=script&lang=js&"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=fe0a9fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0a9fb4",
  null
  
)

export default component.exports